import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ApiClientError, clearAccessToken } from './api';

const STALE_TIME_MS = 30_000;
export const NETWORK_ERROR_MESSAGE = "Couldn't reach Clockit. Check your connection and try again.";
export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

interface WithMeta {
  meta?: Record<string, unknown>;
}

/** Global error toast (architecture.md §8.4). Queries/mutations opt out with meta.silent. */
export function handleGlobalError(error: unknown, source: WithMeta | undefined): void {
  if (source?.meta?.['silent'] === true) return;
  if (error instanceof ApiClientError) {
    if (error.code === 'ACCOUNT_DEACTIVATED') {
      clearAccessToken();
      window.location.assign('/login?error=deactivated');
      return;
    }
    // The SDK has already redirected to /login for an expired session.
    if (error.code === 'SESSION_EXPIRED') return;
    toast.error(error.message);
    return;
  }
  if (error instanceof TypeError) {
    toast.error(NETWORK_ERROR_MESSAGE);
    return;
  }
  toast.error(GENERIC_ERROR_MESSAGE);
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError: (error, query) => handleGlobalError(error, query) }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => handleGlobalError(error, mutation),
    }),
    defaultOptions: { queries: { retry: 1, staleTime: STALE_TIME_MS } },
  });
}
